import axios from 'axios';
import Vue from 'vue';
import store from '@/store';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
  },
});

Vue.prototype.$api = api;

const maintenancePath = `${process.env.BASE_URL || '/'}maintenance`
  .replace(/\/{2,}/g, '/')
  .replace(/\/$/, '') || '/maintenance';

api.interceptors.response.use(
  (response) => {
    console.debug(`HTTP < ${response.status}`);

    if (response.status !== 503 && store.getters['maintenance/isEnabled']) {
      store.dispatch('maintenance/disable');
    }

    return Promise.resolve(response);
  },
  (error) => {
    const status = error.response ? error.response.status : null;
    if (status) {
      console.debug(`HTTP < ${status}`);

      if (status === 503) {
        store.dispatch('maintenance/enable');
        if (window.location.pathname !== maintenancePath) {
          window.location.assign(maintenancePath);
        }
      }
    } else {
      console.debug('HTTP < No response');
      console.error(error);
    }

    return Promise.reject(error);
  },
);

export default api;
